import React from 'react'
import SEO from '../../seo/SEO'
import Career_Banner from './Career_Banner/Career_Banner'
import Second_CareerSection from './Second_CareerSection/Second_CareerSection'
import Third_CareerSection from './Third_CareerSection/Third_CareerSection'
import Forth_CareerSection from './Forth_CareerSection/Forth_CareerSection'
import Fifth_CareerSection from './Fifth_CareerSection/Fifth_CareerSection'

const CareerPageMain = () => {
  return (
          <>
          <SEO />
    <div>
        <Career_Banner/>
        {/* <Second_CareerSection/> */}
        <Third_CareerSection/>
        {/* <Forth_CareerSection/> */}
        <Fifth_CareerSection/>
    </div>
    </>
  )
}

export default CareerPageMain

